import styled from 'styled-components'
import { Box } from 'styling/GlobalStyles'

export const CardWrapper = styled(Box)<{ $borderColor?: string }>`
  height: 100px;
  padding: 1rem;
  display: flex;
  gap: 12px;
  width: 100%;
  border-left: 1.5px solid ${(p) => p.$borderColor ?? p.theme.primary};
  border-radius: 12px;
  align-items: center;
`
